import { Receipt } from 'guest-data-types-ts-lib';

export interface ReceiptState {
    isLoading: boolean;
    error: Error | null;
    receipt?: Receipt;
}

export enum ReceiptActions {
    RECEIPT_FETCH_BEGIN = 'RECEIPT_FETCH_BEGIN',
    RECEIPT_FETCH_SUCCESS = 'RECEIPT_FETCH_SUCCESS',
    RECEIPT_FETCH_ERROR = 'RECEIPT_FETCH_ERROR',
}

interface FetchReceiptBegin {
    type: typeof ReceiptActions.RECEIPT_FETCH_BEGIN;
}

interface FetchReceiptSuccess {
    type: typeof ReceiptActions.RECEIPT_FETCH_SUCCESS;
    payload: Receipt;
}

interface FetchReceiptError {
    type: typeof ReceiptActions.RECEIPT_FETCH_ERROR;
    payload: Error;
}

export type ReceiptActionTypes = FetchReceiptBegin | FetchReceiptSuccess | FetchReceiptError;
